export default {
    getQuickEditStatus(state){
      return state.quickEditActive;
    },
    getNotificationsCount(state){
      return state.notificationsCount;
    },

    
  
  };
  